
export interface Module {
  title: string
  body: string
}

export const modules: Module[] = [
  {
    title: 'Chapter 1',
    body: 'The basics: which flowers press best and when to pick them',
  },
  {
    title: 'Chapter 2',
    body: '9 flower pressing methods, step by step',
  },
  {
    title: 'Chapter 3',
    body: 'Drying times and how to tell when they are ready',
  },
  {
    title: 'Chapter 4',
    body: 'Common mistakes and how to fix them',
  },
  {
    title: 'Chapter 5',
    body: 'Caring for, storing and preserving your flowers',
  },
  {
    title: 'Chapter 6',
    body: '10 botanical projects to create (and sell)',
  },
]
